import { render, staticRenderFns } from "./sceneSelect.vue?vue&type=template&id=1485bfb2&scoped=true&"
import script from "./sceneSelect.vue?vue&type=script&lang=js&"
export * from "./sceneSelect.vue?vue&type=script&lang=js&"
import style0 from "./sceneSelect.vue?vue&type=style&index=0&id=1485bfb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1485bfb2",
  null
  
)

export default component.exports